import { RawFormC, type Form } from '@/scripts/helpers/schemaConverter/converters/types/Form';
import RequestBuilder, { Significance } from '@/scripts/helpers/Request/Builder/RequestBuilder';
import { convertJsonForm, serializeFormFields } from '@/scripts/mixins/jsonSchemaConverter';

export const updateJsonForm = async (
    form: Form,
    updateAction: string,
    preserveUpdatedData = true,
): Promise<Form> => {
    const payload = serializeFormFields(
        form.fields,
        form.name,
        new FormData(),
    );

    payload.append('preserveUpdatedData', preserveUpdatedData ? 'true' : 'false');

    const request = new RequestBuilder(RawFormC)
        .setUrl(updateAction)
        .setSignificance(Significance.Main)
        .setFormData(payload)
        .build();

    const response = await request.send();
    const content = convertJsonForm(response);

    if (content === null) {
        throw new Error('Unable to convert form');
    }

    return content;
};
